// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fcd2ead8","239":"58ae20b4","455":"4104599f"}[chunkId] + ".chunk.js";
};